import React from "react";
import { Intro } from "./pages/intro";
import { Skills } from "./components";
import { MyProjects } from "./components/myProjects";
import { Home } from "./pages";

function App() {
    return <Home />;
}

export default App;
